import { cn } from '@1trading/react/lib/utils';
import React from 'react';

import { useTheme } from '@/context/theme';

const LogoImage = ({ className, ...props }: React.HTMLAttributes<HTMLImageElement> & { src: string }) => {
  return <img {...props} className={cn('h-5.5 md:h-6.5 w-auto', className)} alt="One Trading Logo" />;
};
LogoImage.displayName = 'LogoImage';

const Logo = React.forwardRef<HTMLAnchorElement, React.AnchorHTMLAttributes<HTMLAnchorElement>>(({ href = import.meta.env.VITE_APP_EXCHANGE_URL, ...props }, ref) => {
  const { inferredTheme } = useTheme();

  return (
    <a ref={ref} href={href} {...props}>
      {inferredTheme === 'dark' ? (
        <LogoImage src={`${import.meta.env.VITE_APP_CDN_URL}/img/onetrading-logo-rebrand-white.svg`} />
      ) : (
        <LogoImage src={`${import.meta.env.VITE_APP_CDN_URL}/img/onetrading-logo-rebrand-blue-black.svg`} />
      )}
    </a>
  );
});
Logo.displayName = 'Logo';

export default Logo;
